export const PaginationCustomer = ({changePage, pageCount, currentPage}) => {
    const handlePageClick = (page) => {
        changePage(page);
    };

    return (<div className="row mt-4">
        <div className="col-lg-12">
            <ul className="paginationBttns" role="navigation" aria-label="Pagination">
                <li className={`previous ${currentPage === 1 ? "paginationDisabled" : ""}`}>
                    <a className="previousBttn"
                       tabIndex={currentPage === 1 ? -1 : 0}
                       role="button"
                       aria-disabled={currentPage === 1}
                       aria-label="Previous page"
                       rel="prev"
                       onClick={() => handlePageClick(currentPage - 1)}>
                        Previous
                    </a>
                </li>

                {Array.from({length: pageCount}, (_, i) => i + 1).map((page) => (
                    <li key={page} className={page === currentPage ? "paginationActive" : ""}>
                        <a role="button"
                           tabIndex={0}
                           aria-label={`Page ${page} ${page === currentPage ? "is your current page" : ""}`}
                           aria-current={page === currentPage ? "page" : undefined}
                           onClick={() => handlePageClick(page)}>
                            {page}
                        </a>
                    </li>))}

                <li className={`next ${currentPage === pageCount ? "paginationDisabled" : ""}`}>
                    <a className="nextBttn"
                       tabIndex={currentPage === pageCount ? -1 : 0}
                       role="button"
                       aria-disabled={currentPage === pageCount}
                       aria-label="Next page"
                       rel="next"
                       onClick={() => handlePageClick(currentPage + 1)}>
                        Next
                    </a>
                </li>
            </ul>
        </div>
    </div>);
};
